import { render } from "./SustainabilityNavBar.vue?vue&type=template&id=88a3b8c6&scoped=true"
import script from "./SustainabilityNavBar.vue?vue&type=script&lang=js"
export * from "./SustainabilityNavBar.vue?vue&type=script&lang=js"

import "./SustainabilityNavBar.vue?vue&type=style&index=0&id=88a3b8c6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88a3b8c6"]])

export default __exports__